(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('GpfsBatchInvoiceDialogController', GpfsBatchInvoiceDialogController);

    GpfsBatchInvoiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GpfsBatchInvoice', 'GpfsBatch', 'Invoice'];

    function GpfsBatchInvoiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GpfsBatchInvoice, GpfsBatch, Invoice) {
        var vm = this;

        vm.gpfsBatchInvoice = entity;
        vm.clear = clear;
        vm.save = save;
        vm.gpfsbatches = GpfsBatch.query();
        vm.invoices = Invoice.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.gpfsBatchInvoice.id !== null) {
                GpfsBatchInvoice.update(vm.gpfsBatchInvoice, onSaveSuccess, onSaveError);
            } else {
                GpfsBatchInvoice.save(vm.gpfsBatchInvoice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:gpfsBatchInvoiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
